import React from 'react'
import clsx from 'clsx'
import { makeStyles } from '@mui/styles'

import SVGIcon from '@/modules/base/components/svg-icon/svg-icon'
import PresentIcon from '@assets/images/icons/present.svg'
import ThemeInterface from '@/theme-interface'

const useStyles = makeStyles((theme: ThemeInterface) => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  },
  // eslint plugin doesn't recognize animations used in other styles
  // eslint-disable-next-line
  '@keyframes borderSlideIn': {
    from: { transform: 'translate3d(100%, 0, 0)' },
    to: { transform: 'translate3d(0, 0, 0)' },
  },
  presentIcon: {
    position: 'relative',
    '& path': {
      fill: theme.white,
    },
    '&:hover path': {
      fill: theme.primary,
    },
  },
  hideActiveIcon: {
    '&:after': {
      display: 'none',
    },
  },
  iconWrapper: {
    position: 'relative',
  },
  [theme.devices.mobile]: {
    container: {
      flexDirection: 'row',
      margin: 0,
      width: 'auto',
    },
    iconWrapper: {
      marginRight: 30,
    },
    newsIcon: {
      marginRight: 70,
    },
    presentIcon: {
      height: 20,
    },
  },
}))

interface CelloButtonProps {
  iconSize?: { width: number, height: number },
  hideActiveIcon?: boolean,
  styles?: { root?: string, badge?: string },
}

const CelloButton = (props: CelloButtonProps) => {
  const {
    iconSize = { width: 20, height: 20 },
    hideActiveIcon,
    styles = { root: null, badge: null },
  } = props
  const classes = useStyles()

  const className = clsx(
    classes.container,
    classes.iconWrapper,
    classes.newsIcon,
    styles?.root && styles.root,
    hideActiveIcon && classes.hideActiveIcon,
    'celloButton',
  )

  return (
    <a
      className={className}
      id="cello-referral-button"
      data-qs-id='cello-menu-button'>
      <span className={classes.presentIcon}>
        <SVGIcon
          width={`${iconSize.width}px`}
          height={`${iconSize.height}px`}
          svg={PresentIcon}
        />
      </span>
    </a>
  )
}

export default CelloButton
